import {requestHost} from '../host/client';
import type {BgmSource} from '../../protocol/bgm-catalog';
export async function readBgmFile(url:string,source?:BgmSource,signal?:AbortSignal):Promise<Blob>{
  if(signal?.aborted)throw new Error('배경음 추가를 취소했습니다.');
  if(source){
    if(source.url!==url)throw new Error('배경음 원본 주소가 다릅니다.');
    const blob=await requestHost({method:'GET',path:'/__waka/bgm-file',params:{id:source.id,url}});
    if(signal?.aborted)throw new Error('배경음 추가를 취소했습니다.');
    if(!(blob instanceof Blob)||!blob.size||!blob.type.startsWith('audio/'))throw new Error('배경음 파일을 확인하지 못했습니다.');return blob;
  }
  const response=await fetch(url,{credentials:'omit',signal});if(!response.ok)throw new Error('배경음 파일을 받지 못했습니다.');return response.blob();
}
